import PortalIdParser from 'PortalIdParser';
import http from 'hub-http/clients/apiClient';
import { registerMutation, useMutation, registerQuery } from 'data-fetching-client';
import I18n from 'I18n';
import { jsx as _jsx } from "react/jsx-runtime";
const ENROLLMENT_TRIGGER_FIELDNAME = 'enrollmentTrigger';

/**
 * Updates the enrollmentTrigger on a given flow
 */
export const UPDATE_ENROLLMENT_TRIGGER_TYPE = registerMutation({
  fieldName: ENROLLMENT_TRIGGER_FIELDNAME,
  args: ['flowId', 'enrollmentTrigger'],
  fetcher({
    flowId,
    enrollmentTrigger
  }) {
    return http.post(`automationplatform/v1/enrollment-trigger/${flowId}`, {
      data: {
        portalId: PortalIdParser.get(),
        flowId,
        enrollmentTrigger
      }
    });
  }
});

// Don't actually use this. Needed to propagate the inferred generic type parameters to the return type
const _useMutationReturnTypeHack = () => useMutation(UPDATE_ENROLLMENT_TRIGGER_TYPE);
export const wireUpdateEnrollmentTriggerType = WrappedComponent => props => {
  const [updateEnrollmentTriggerType] = useMutation(UPDATE_ENROLLMENT_TRIGGER_TYPE);
  return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, props, {
    updateEnrollmentTriggerType: updateEnrollmentTriggerType
  }));
};
export const GENERATE_FILTERS_FROM_EVENT_TRIGGERS = registerQuery({
  fieldName: 'filtersFromCurrentTriggers',
  args: ['associatedLists', 'flowEventFilters', 'useRefinementCriteria'],
  fetcher({
    associatedLists,
    flowEventFilters,
    useRefinementCriteria
  }) {
    return http.post('automation-enrollment/v1/bulk-enrollments/generate-filters', {
      data: {
        useRefinementCriteria,
        associatedLists,
        flowEventFilters
      }
    });
  }
});
export const BULK_ENROLL_FROM_LIST_FILTERS = registerQuery({
  fieldName: 'enrollmentFromCurrentTriggers',
  args: ['flowId', 'objectType', 'filterBranch'],
  fetcher({
    flowId,
    objectType,
    filterBranch
  }) {
    return http.post('automation-enrollment/v1/bulk-enrollments', {
      data: {
        flowId,
        objectSelector: {
          type: 'LIST_FILTER',
          objectType,
          filterBranch
        }
      }
    });
  }
});
export const ENROLL_RECORD = registerQuery({
  fieldName: 'enrollRecord',
  args: ['flowId', 'recordCoordinates'],
  fetcher({
    flowId,
    recordCoordinates
  }) {
    return http.post('automation-enrollment/v1/enrollments/flow/enroll', {
      data: {
        flowId,
        recordCoordinates: Object.assign({
          idempotencyId: I18n.moment().unix()
        }, recordCoordinates)
      }
    });
  }
});